module.exports = __webpack_public_path__ + "media/images/plans/dinner/point-3-69aff77641df70f5101530e5f961cf66.jpg";